<template>
  <div v-if="isLoading">
    <div class="text-center text-danger screen-center">
      <div class="align-middle spinner-bubble spinner-bubble-danger mr-5"></div>
      <strong>Cargando...</strong>
    </div>
  </div>
  <div v-else>
    <div>
      <div class="row mr-0">
        <div class="col-sm-4">
          <div class="breadcrumb">
            <h1>
              Orden de Trabajo
              <span class="h4 pl-2"> N°: {{ ordenTrabajoData.orden_trabajo.numero }} </span>
            </h1>
          </div>
        </div>
        <transition name="fade">
          <div class="col-sm-6 pl-0 navbar-reubicado">
            <div class="row mx-0">
              <div
                class="col-sm-3 py-2 bg-sky-light text-white border-left border-white"
              >
                <b>Edad:</b> {{ pacienteDto.edad }} Años
              </div>
              <div class="col-sm-3 px-1 py-2 bg-sky-light text-white">
                <template> <b>N° Poliza: </b> {{ pacienteDto.numero_poliza }} </template>
              </div>
            </div>
          </div>
        </transition>
        <div class="col-sm-2 text-right">{{ordenTrabajoData.data_venta.tipo }}: {{ ordenTrabajoData.data_venta.numero }}</div>
      </div>
        <div class="row mb-2">
        <div class="col-sm-12">
          <div class="card text-left">
            <div class="card-header">
              <div class="row">
                <div class="col-sm-5">
                  <button
                    class="btn btn-white border border-light mr-2"
                    @click="regresarDoctor"
                  >
                    Regresar
                  </button>
                  <button
                    type="button"
                    class="btn btn-dark mr-2"
                    @click="guardarOrden"
                  >
                    Guardar
                  </button>
                  <button
                    type="button"
                    class="btn bg-custom-green mr-2"
                    @click="guardarYCerrar"
                  >
                    Guardar y Cerrar
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-6">
                  <div class="row">
                <div class="col-sm-12">
                  <div class="row pt-3">
                    <div class="col d-flex"><strong>Fecha: </strong>
                      <div class="px-3">
                        {{ ordenTrabajoData.orden_trabajo.fecha }} - Iniciado {{ ordenTrabajoData.orden_trabajo.hora}}
                      </div>
                    </div>
                  </div>
                  <div class="row pb-3" v-if="pacienteDto">
                    <div class="col-12"><strong>Paciente:</strong>
                      {{ pacienteDto.full_name }}
                      ({{ pacienteDto.edad }} años) - N° HC: {{ pacienteDto.numero }}
                    </div>
                  </div>
                </div>
              </div>
               <div class="form-group mt-2 text-center" style="background: darkseagreen;">
                    <strong>{{ordenTrabajoData.data_venta.servicio}}</strong>
                </div>
                  <div
                    v-if="cantidad_diagnostico >= 1"
                    class="form-group mt-2"
                  >
                     <b-card class="border border-light small-card">
                      <b class="small-text">Diagnóstico: </b>
                      <div class="row mt-1 mb-2">
                        <ComboDiagnostic
                          :id="'comboDiagnostic'"
                          class="small-combo-diagnostic"
                          @addDiagnostico="guardarDiagnosticoSeleccionado"
                        />
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <input
                            id="inputDiagnostico"
                            v-model="diagnostico"
                            type="text"
                            class="form-control small-input"
                          >
                        </div>
                      </div>
                    </b-card>
                  </div>
                  <div
                    v-if="cantidad_diagnostico >= 3"
                    class="form-group mt-4"
                  >
                    <b-card class="border border-light">
                        <b>Diagnóstico 3: </b>
                        <div class="row mt-1 mb-2">
                        <ComboDiagnostic
                        :id="'comboDiagnostic-3'"
                        :key="'comboDiagnostic-3'"
                        :diagnostico-inicial="diagnostico3Selected"
                        @addDiagnostico="(diagnostico) => guardarDiagnosticoSeleccionado(diagnostico, 3)"
                        />
                        </div>
                        <div class="row">
                        <div class="col-sm-12">
                            <input
                            id="inputDiagnostico"
                            v-model="descripcionDiagnostico3"
                            type="text"
                            class="form-control"
                            >
                        </div>
                        </div>
                    </b-card>
                  </div>
                   <div class="form-group">
                        <label>Conclusión:</label>
                        <vue-editor
                        v-model="content"
                        class="editor-contenido"
                        :editor-toolbar="customToolbar"
                        useCustomImageHandler
                        @image-added="handleImageUpload"
                        />
                    </div>
                     <div class="form-group">
                        <label>Enlace de Información:</label>
                        <input type="text" v-model="enlace" class="form-control" placeholder=""/>
                    </div>

                    <!-- Campo Adjuntar Imagen y Almacén -->
                    <div class="form-group row">
                        <div class="col-sm-6">
                          <label class="d-block">Imágenes adjuntas</label>
                          <button
                            type="button"
                            class="btn btn-outline-primary"
                            @click="abrirModalImagenes"
                          >
                            <i class="i-Gallery"></i> Ver imágenes subidas
                            <span
                              v-if="totalImagenes > 0"
                              class="badge badge-success ml-2"
                            >
                              {{ totalImagenes }}
                            </span>
                          </button>
                        </div>
                        <div class="col-sm-6">
                          <label class="d-block">Almacén</label>
                          <multiselect2
                            id="almacen"
                            v-model="almacenSelected"
                            track-by="id"
                            label="nombre"
                            placeholder="Seleccione un almacén"
                            :options="almacen"
                            :searchable="true"
                          />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                  <div
                    v-if="cantidad_diagnostico >= 2"
                    class="form-group mt-4"
                  >
                  <b-card class="border border-light">
                    <b>Diagnóstico 2: </b>
                    <div class="row mt-1 mb-2">
                      <ComboDiagnostic
                      :id="'comboDiagnostic-2'"
                      :key="'comboDiagnostic-2'"
                      :diagnostico-inicial="diagnostico2Selected"
                      @addDiagnostico="(diagnostico) => guardarDiagnosticoSeleccionado(diagnostico, 2)"/>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <input
                          id="inputDiagnostico"
                          v-model="descripcionDiagnostico2"
                          type="text"
                          class="form-control"
                        >
                      </div>
                    </div>
                  </b-card>
                  </div>
                  <div
                    v-if="cantidad_diagnostico >= 4"
                    class="form-group mt-4"
                  >
                    <b-card class="border border-light">
                        <b>Diagnóstico 4: </b>
                        <div class="row mt-1 mb-2">
                        <ComboDiagnostic
                        :id="'comboDiagnostic-4'"
                        :key="'comboDiagnostic-4'"
                        :diagnostico-inicial="diagnostico4Selected"
                        @addDiagnostico="(diagnostico) => guardarDiagnosticoSeleccionado(diagnostico, 4)"
                        />
                        </div>
                        <div class="row">
                        <div class="col-sm-12">
                            <input
                            id="inputDiagnostico"
                            v-model="descripcionDiagnostico4"
                            type="text"
                            class="form-control"
                            >
                        </div>
                        </div>
                    </b-card>
                  </div>
                  <TableDetalleOrden
                  :pacienteId="pacienteDto.id"
                  :almacen="almacen"
                  :ordenTrabajoData="ordenTrabajoData"
                  @listaDetalles="actualizarDetalles"
                  @entregado="onEntregado"
                  :almacenSelected="almacenSelected"
                  :medico_id="medico_id"
                  :cierre="cierre"
                  :clasificacion-cie="clasificacionCIESeleccionado"
                  :subclasificacion-cie="subclasificacionCIESeleccionado"
                  :diagnostico="diagnostico"
                  :conclusion="content"
                  :enlace-informacion="enlace"
                  :imagenes-eliminar="imagenesEliminar"
                  ></TableDetalleOrden>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de confirmación para eliminar imagen -->
    <b-modal
      id="modalConfirmarEliminar"
      ref="modalConfirmarEliminar"
      title="Confirmar Eliminación"
      size="sm"
      ok-variant="danger"
      ok-title="Eliminar"
      cancel-title="Cancelar"
      @ok="confirmarEliminarImagen"
    >
      <div class="text-center">
        <i class="i-Close-Window text-danger" style="font-size: 48px;"></i>
        <p class="mt-3 mb-0">¿Está seguro de eliminar esta imagen?</p>
      </div>
    </b-modal>

    <!-- Modal para gestionar imágenes -->
    <b-modal
      id="modalImagenes"
      ref="modalImagenes"
      title="Imágenes"
      size="xl"
      ok-title="Guardar"
      cancel-title="Cancelar"
      @ok="guardarCambiosImagenes"
      @cancel="cancelarCambiosImagenes"
    >
      <div class="container-fluid">
        <!-- Galería de imágenes en grid -->
        <div class="row">
          <!-- Imágenes existentes -->
          <div
            v-for="(imagen, index) in orden_trabajo_imagenes"
            :key="'existente-' + imagen.id"
            class="col-lg-3 col-md-4 col-sm-6 col-6 mb-3"
          >
            <div class="card shadow-sm h-100">
              <div class="position-relative">
                <img
                  :src="imagen.ruta"
                  :alt="'Imagen ' + (index + 1)"
                  class="card-img-top"
                  style="height: 150px; object-fit: cover; cursor: pointer;"
                  @click="verImagenCompleta(imagen.ruta)"
                />
                <button
                  type="button"
                  class="btn btn-danger btn-sm position-absolute"
                  style="top: 5px; right: 5px; padding: 2px 8px; opacity: 0.9;"
                  @click="eliminarImagenExistente(index, imagen.id)"
                  title="Eliminar imagen"
                >
                  <i class="i-Close"></i>
                </button>
              </div>
              <div class="card-footer p-1 text-center small bg-light">
                <small class="text-muted">Imagen {{ index + 1 }}</small>
              </div>
            </div>
          </div>

          <!-- Nuevas imágenes agregadas (preview) -->
          <div
            v-for="(img, index) in imagenes"
            :key="'nueva-' + index"
            class="col-lg-3 col-md-4 col-sm-6 col-6 mb-3"
          >
            <div class="card shadow-sm h-100 border-success">
              <div class="position-relative bg-light">
                <div
                  class="d-flex align-items-center justify-content-center"
                  style="height: 150px;"
                >
                  <i class="i-File-Picture text-success" style="font-size: 48px;"></i>
                </div>
                <button
                  type="button"
                  class="btn btn-danger btn-sm position-absolute"
                  style="top: 5px; right: 5px; padding: 2px 8px; opacity: 0.9;"
                  @click="eliminarNuevaImagen(index)"
                  title="Quitar imagen"
                >
                  <i class="i-Close"></i>
                </button>
                <span
                  class="badge badge-success position-absolute"
                  style="top: 5px; left: 5px;"
                >
                  Nueva
                </span>
              </div>
              <div class="card-footer p-1 text-center small bg-success text-white">
                <small class="text-truncate d-block">{{ img.name }}</small>
              </div>
            </div>
          </div>

          <!-- Mensaje si no hay imágenes -->
          <div
            v-if="!orden_trabajo_imagenes.length && !imagenes.length"
            class="col-12"
          >
            <div class="alert alert-info text-center mb-0">
              <i class="i-Information"></i>
              No hay imágenes adjuntas.
            </div>
          </div>
        </div>

        <!-- Botón agregar imagen -->
        <div class="text-center mt-3">
          <label class="btn btn-success btn-sm mb-0">
            <i class="i-Add"></i> Agregar imagen
            <input
              type="file"
              accept="image/*"
              hidden
              @change="handleFileInputChange"
            />
          </label>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { VueEditor } from 'vue2-quill-editor';
import { mapActions } from 'vuex';
import axios from '@/modules/common/axiosERP';
import { util } from '@/plugins/util';
import Multiselect2 from '@/components/util/vue-multiselect2';
import ComboDiagnostic from '../../tratamiento/components/TheDiagnostic.vue';
import TableDetalleOrden from '../components/TableDetalleOrden.vue';

export default {
  name: 'Orden-Trabajo',
  data() {
    return {
      isLoading: false,
      medico_id: null,
      pacienteDto: {
        paciente_id: 0,
        fecha_nacimiento: '',
        full_name: '',
        edad: 0,
        numero: '',
      },
      ordenTrabajoData: null,
      clasificacionCIESeleccionado: null,
      subclasificacionCIESeleccionado: null,
      content: '',
      customToolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['blockquote', 'code-block'],
        ['link', 'image'],
        [{ align: [] }],
        [{ color: [] }, { background: [] }],
        ['clean'],
      ],
      enlace: '',
      imagenes: [],
      imagenesEliminar: [], // IDs de imágenes existentes a eliminar
      imagenAEliminar: { index: null, id: null }, // Temporal para confirmación
      diagnostico: '',
      diagnosticoSeleccionado: null,
      conclusion: '',
      cantidad_diagnostico: 1,
      almacen: null,
      almacenSelected: null,
      detalles: [],
      cierre: false,
      orden_trabajo_detalles: null,
      orden_trabajo_imagenes: [],
      monedas: null,
      diagnostico_selected: null,
    };
  },
  async created() {
    await this.loadOrdenTrabajo();
  },
  components: {
    ComboDiagnostic,
    TableDetalleOrden,
    VueEditor,
    Multiselect2,
  },
  methods: {
    encrypt(id) {
      return btoa(id);
    },
    decrypt(encodedValue) {
      try {
        return atob(encodedValue);
      } catch (error) {
        console.error('Error al desencriptar:', error);
        return null;
      }
    },
    regresarDoctor() {
      if (this.medico_id) {
        // Si viene de grupal, regresar a grupal
        if (this.$route.query.grupal === 'true') {
          this.$router.push({
            name: 'orden-trabajo-grupal',
            params: { id: this.encrypt(this.medico_id) },
          });
        } else {
          this.$router.push({
            name: 'orden-trabajo-doctor',
            params: { id: this.encrypt(this.medico_id) },
          });
        }
      } else {
        this.$router.push({ name: 'orden-trabajo-index' });
      }
    },
    actualizarDetalles(detallesRecibidos) {
      this.detalles = detallesRecibidos;
    },
    onEntregado() {
      // Después de dar de baja insumos, redirigir al listado
      this.regresarDoctor();
    },
    async guardarOrden() {
      try {
        this.isLoading = true;

        // Crear el objeto dataJson
        const dataJson = {
          clasificacion_cie_id: this.clasificacionCIESeleccionado?.id || null,
          subclasificacion_cie_id: this.subclasificacionCIESeleccionado?.id || null,
          diagnostico: this.diagnostico || '',
          conclusion: this.content || '',
          enlace_informacion: this.enlace || '',
          medico_id: this.medico_id,
          estado_orden_id: this.ordenTrabajoData?.orden_trabajo?.estado_orden_id || 2,
          almacen_id: this.almacenSelected?.id || null,
          cierre: this.cierre,
          detalles: this.detalles || [],
          imagenes_eliminar: this.imagenesEliminar || [],
        };

        // Crear FormData para enviar archivos e información
        const formData = new FormData();
        formData.append('dataJson', JSON.stringify(dataJson));

        // Agregar archivos (imágenes)
        if (this.imagenes && this.imagenes.length > 0) {
          this.imagenes.forEach((imagen) => {
            formData.append('files[]', imagen);
          });
        }

        // Hacer la petición POST
        const response = await axios.post(
          `/clinic/orden_trabajo/update/${this.ordenTrabajoData.orden_trabajo.id}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        );

        util.showNotify(
          response.data?.message || 'Orden de trabajo guardada exitosamente',
          'success',
        );

        this.regresarDoctor();
      } catch (error) {
        console.error('Error al guardar orden de trabajo:', error);
        util.showNotify(
          error.response?.data?.message || 'Error al guardar la orden de trabajo',
          'error',
        );
      } finally {
        this.isLoading = false;
      }
    },
    async guardarYCerrar() {
      this.cierre = true;
      await this.guardarOrden();
    },
    ...mapActions('ConsultaExternaEdit', [
      'edit',
      'resetState',
      'create',
      'store',
    ]),
    async loadOrdenTrabajo() {
      try {
        this.isLoading = true;
        const { params, query } = this.$route;

        // Desencriptar los parámetros de la URL
        const ordenTrabajoId = this.decrypt(params.id);
        const medicoId = this.decrypt(query.medico_id);
        const estadoOrdenId = this.decrypt(query.estado_orden_id);

        // Guardar el medico_id para uso posterior
        this.medico_id = medicoId;

        const queryParams = {
          medico_id: medicoId,
          estado_orden_id: estadoOrdenId,
        };

        const response = await axios.get(`/clinic/orden_trabajo/edit/${ordenTrabajoId}`, {
          params: queryParams,
        });
        this.ordenTrabajoData = response.data.data;
        this.pacienteDto = this.ordenTrabajoData.paciente;
        this.content = this.ordenTrabajoData.conclusion || '';
        this.cantidad_diagnostico = this.ordenTrabajoData.cantidad_diagnostico;
        this.almacen = this.ordenTrabajoData.almacenes;
        this.orden_trabajo_detalles = this.ordenTrabajoData.detalles || [];
        this.orden_trabajo_imagenes = this.ordenTrabajoData.orden_trabajo_imagenes || [];
        this.monedas = this.ordenTrabajoData.moneda || null;
        this.diagnostico_selected = this.ordenTrabajoData.diagnostico_selected || null;
        this.content = this.ordenTrabajoData.orden_trabajo.conclusion || '';
        this.enlace = this.ordenTrabajoData.orden_trabajo.enlace_informacion || '';
        this.almacenSelected = this.almacen.find((item) => item.id === this.ordenTrabajoData.almacenes[0].pivot.almacen_id);
      } catch (error) {
        console.error('Error al cargar orden de trabajo:', error);
        util.showNotify(
          error.response?.data?.message || 'Error al cargar la orden de trabajo',
          'error',
        );
      } finally {
        this.isLoading = false;
      }
    },
    guardarDiagnosticoSeleccionado(diagnostico, indice) {
      if (diagnostico) {
        this.clasificacionCIESeleccionado = diagnostico;
        this[`diagnostico${indice}Selected`] = this.clasificacionCIESeleccionado;
        this[`sub_clasificacion_cie${indice}`] = this[`diagnostico${indice}Selected`].id_sub;
      } else {
        this.clasificacionCIESeleccionado = null;
        this[`diagnostico${indice}Selected`] = null;
        this[`sub_clasificacion_cie${indice}`] = null;
      }
    },
    handleFileInputChange(event) {
      const file = event.target.files[0];
      const input = event.target;
      if (file) {
        // Validar que sea una imagen
        if (!file.type.startsWith('image/')) {
          util.showNotify('Por favor seleccione un archivo de imagen válido', 'error');
          input.value = '';
          return;
        }
        // Agregar el archivo al array de imágenes para enviar al guardar
        this.imagenes.push(file);
        util.showNotify(`Imagen "${file.name}" agregada correctamente`, 'success');
        // Reset input para permitir seleccionar el mismo archivo de nuevo
        input.value = '';
      }
    },
    eliminarImagenExistente(index, imagenId) {
      // Guardar temporalmente los datos
      this.imagenAEliminar = { index, id: imagenId };
      // Abrir modal de confirmación
      this.$refs.modalConfirmarEliminar.show();
    },
    confirmarEliminarImagen() {
      // Agregar el ID a la lista de imágenes a eliminar
      this.imagenesEliminar.push(this.imagenAEliminar.id);
      // Remover visualmente de la lista
      this.orden_trabajo_imagenes.splice(this.imagenAEliminar.index, 1);
      util.showNotify('Imagen marcada para eliminación', 'success');
      // Limpiar temporal
      this.imagenAEliminar = { index: null, id: null };
    },
    eliminarNuevaImagen(index) {
      // Eliminar del array de nuevas imágenes
      this.imagenes.splice(index, 1);
      util.showNotify('Imagen quitada de la lista', 'success');
    },
    abrirModalImagenes() {
      this.$refs.modalImagenes.show();
    },
    guardarCambiosImagenes() {
      // El modal se cierra automáticamente
      // Los cambios ya están guardados en los arrays
      util.showNotify('Cambios guardados. Presiona "Guardar" en la orden para aplicarlos.', 'info');
    },
    cancelarCambiosImagenes() {
      // Opcional: podrías revertir cambios si lo deseas
      // Por ahora solo cierra el modal
    },
    verImagenCompleta(url) {
      // Abrir imagen en nueva pestaña
      window.open(url, '_blank');
    },
    async handleImageUpload(file, Editor, cursorLocation, resetUploader) {
      // Para el editor de texto (VueEditor)
      // Si necesitas subir imágenes desde el editor, debes configurar la ruta del servidor
      const formData = new FormData();
      formData.append('image', file);

      try {
        // Cambiar '/api/upload' por la ruta correcta de tu backend
        const response = await axios.post('/clinic/upload-image', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        const imageUrl = response.data.url;
        Editor.insertEmbed(cursorLocation, 'image', imageUrl);
        resetUploader();
      } catch (error) {
        console.error('Error al subir imagen:', error);
        util.showNotify('Error al subir la imagen al editor', 'error');
        resetUploader();
      }
    },
  },
  computed: {
    totalImagenes() {
      const existentes = this.orden_trabajo_imagenes?.length || 0;
      const nuevas = this.imagenes?.length || 0;
      return existentes + nuevas;
    },
  },
};
</script>

<style>

.btnOrange {
  color: white;
  background-color: #F4B375;
}
.info-tratamiento-paciente {
  position: relative;
  top: -48px;
  height: 60px;
  right: 60px;
}
.background-title {
  background: yellow;
}
.bg-sky-light
{
  background:#a6d2eb;
}
.navbar-reubicado
{
  transform: translate(18%, -32px);
  white-space: nowrap;
}
.textarea-ce {
  border:1px solid black;
}
.editor-contenido .ql-container {
  height: 200px !important;
}
</style>
